import requests from "./httpService";
import dayjs from "dayjs";

const ReportService = {
    getAllEmployeeReport: async ({ employeeId, departmentId, designationId, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/employee?employeeId=${employeeId}&department=${departmentId}&designation=${designationId}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit=${limit}`);
    },

    getAllScheduleReport: async ({ employeeId, clientId, fromDate, toDate, project, status, page, limit }) => {
        if (fromDate !== "" && fromDate !== 'undefined') {
            var startTime = fromDate;
            startTime = startTime.replace("T", " ")
            startTime = dayjs(startTime).format("YYYY-MM-DD HH:mm:ss");
        }
        if (toDate !== "" && toDate !== 'undefined') {
            var endTime = toDate + "23:59:59";
            endTime = endTime.replace("T", " ")
            endTime = dayjs(endTime).format("YYYY-MM-DD HH:mm:ss");
        }
        return requests.post(`/report/schedule?employeeId=${employeeId}&clientId=${clientId}&fromDate=${startTime}&toDate=${endTime}&project=${project}&status=${status}&page=${page}&limit${limit}`);
    },

    getAllQuotationReport: async ({ employeeId, clientId, status, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/quotation?employeeId=${employeeId}&clientId=${clientId}&status=${status}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit${limit}`);
    },
    getAllClientReportData: async ({ clientId, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/client?clientId=${clientId}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit=${limit}`);
    },
    getAllProjectReportData: async ({ projectId, search, projectStatus, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/project?projectId=${projectId}&search=${search}&projectStatus=${projectStatus}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit=${limit}`);
    },
    getAllSheduleReportData: async ({ employeeId, clientId, fromDate, toDate, project, status, page, limit }) => {
        return requests.post(`/report/schedule?employeeId=${employeeId}&clientId=${clientId}&fromDate=${fromDate}&toDate=${toDate}&project=${project}&status=${status}&page=${page}&limit=${limit}`);
    },
    getAllQuotationReportData: async ({ clientId, employeeId, status, page, limit }) => {
        return requests.post(`/report/quotation?clientId=${clientId}&employeeId=${employeeId}&status=${status}&page=${page}&limit=${limit}`);
    },
    getAllEmployeeLeaveReportData: async ({ employeeId, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/employee-leave?employeeId=${employeeId}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit=${limit}`);
    },
    getAllEmployeeAttenanceReportData: async ({ employeeId, fromDate, toDate, page, limit }) => {
        return requests.post(`/report/employee-attenance?employeeId=${employeeId}&fromDate=${fromDate} 00:00:00&toDate=${toDate} 00:00:00&page=${page}&limit=${limit}`);
    },
}

export default ReportService;